const { useIntl } = require('react-intl');
const {datadogLogs} = require('@datadog/browser-logs');
const LanguageConverterV2 = (text, value) => {
  const intl = useIntl();
  if (!intl.messages || !intl.messages[text]) {
    datadogLogs.logger.error(`Missing i18n key: ${text}`);
    return `[Missing translation: ${text}]`;
  }
  return intl.formatMessage({ id: text }, value);
};

module.exports =  LanguageConverterV2;